import {
  ICustomer,
  IEditCustomer,
  ICustomerFileCreate,
  IParamsGetCustomer,
  IParamsGetCustomerSelection,
  IParamsOrganization,
  IPayloadDelete,
  IResponseGetListCustomer,
  IResponseGetOrganization,
  IResponseGetCRMBoard,
} from '~/utils/interface/customer';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IResponseGetFiles } from '~/utils/interface/customer';
import { IEditNote } from '~/utils/interface/note';
import { IPayloadDeleteJobsFile, IResponseGetNote } from '~/utils/interface/job';
import { appendToFormData } from '~/utils/helper';
import { IJobFolderCreate, IResponseGetFolders } from '~/utils/interface/folder';
import { ISendMail } from '~/utils/interface/mail';

const url = `api/admin/customers`;

const customerApi = {
  create(data: IEditCustomer) {
    return axiosClient.post<IApiBaseResponse<ICustomer>>(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  sendMail(data: ISendMail) {
    return axiosClient.post<IApiBaseResponse<ISendMail>>(`api/admin/mails`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getSelectCustomer(params?: IParamsGetCustomerSelection) {
    return axiosClient.get<IApiBaseResponse<IResponseGetOrganization>>('api/admin/customers/selection', { params });
  },

  getListCustomer(params: IParamsGetCustomer) {
    return axiosClient.get<IApiBaseResponse<IResponseGetListCustomer>>(url, { params });
  },
  getBoard(params: IParamsGetCustomer) {
    return axiosClient.get<IApiBaseResponse<IResponseGetCRMBoard>>(`${url}/board`, { params });
  },

  getContactDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<ICustomer>>(`api/admin/customers/${id}/contact`);
  },
  getDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<ICustomer>>(`api/admin/customers/${id}`);
  },
  delete(data: IPayloadDelete) {
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  update(id: string | undefined, data: IEditCustomer) {
    return axiosClient.put<IApiBaseResponse<ICustomer>>(`api/admin/customers/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  updateFields(id: string | undefined, data: IEditCustomer) {
    return axiosClient.put<IApiBaseResponse<ICustomer>>(`api/admin/customers/${id}/fields`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getOrganization(params: IParamsOrganization) {
    return axiosClient.get<IApiBaseResponse<IResponseGetOrganization>>(url, { params });
  },
  getFiles(id: string | undefined) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFiles>>(`api/admin/customers/${id}/files/selection`);
  },

  getCustomerFiles(id: string | undefined, params: ICustomerFileCreate) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFiles>>(`api/admin/customers/${id}/files`, { params });
  },

  createUploadFiles(id: string | undefined, data: FormData) {
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/customers/${id}/uploadFiles`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateNotes(id: string | number, data: IEditNote) {
    return axiosClient.put<IApiBaseResponse<IResponseGetNote>>(`api/admin/notes/${id}`, data);
  },

  createNotes(data: IEditNote) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['files']);
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/notes`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getFolders(id: string | undefined, params: IJobFolderCreate) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFolders>>(`api/admin/customers/${id}/folders`, { params });
  },

  deleteFiles(id: string | undefined, data: IPayloadDeleteJobsFile) {
    return axiosClient.delete<IApiBaseResponse<null>>(`api/admin/customers/${id}/files`, { data });
  },
  export(params: IParamsGetCustomer) {
    return axiosClient.get<IApiBaseResponse<null>>(`api/admin/customers/export`, { params });
  },
};

export default customerApi;
